module.exports = __webpack_public_path__ + "static/media/img_public_utilities.17a1bc59.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/views/facility/img_public_utilities.png
// module id = 1604
// module chunks = 0